const AzurePipelineMarkets = [
  { key: 'gl', label: 'Global 🌍', flag: '🌍', default: true, region: 'we' },
  { key: 'elev8', label: 'Elev8 🌍', flag: '🌍', default: true, region: 'we' },
  { key: 'demo1', label: 'Demo 1️⃣ (QA only)', flag: ' 1️⃣', default: false, region: 'other' },
  { key: 'demo2', label: 'Demo 2️⃣ (QA only)', flag: '2️⃣', default: false, region: 'other' },
  { key: 'demo3', label: 'Demo 3️⃣ (QA only)', flag: '3️⃣', default: false, region: 'other' },
  { key: 'demo4', label: 'Demo 4️⃣ (QA only)', flag: '4️⃣', default: false, region: 'other' },
  { key: 'demo5', label: 'Demo 5️⃣ (QA only)', flag: '5️⃣️', default: false, region: 'other' },
  { key: 'dz', label: 'Algeria 🇩🇿', flag: '🇩🇿', default: false, region: 'we' },
  { key: 'am', label: 'Armenia 🇦🇲', flag: '🇦🇲', default: false, region: 'we' },
  { key: 'at', label: 'Austria 🇦🇹', flag: '🇦🇹', default: false, region: 'we' },
  { key: 'az', label: 'Azerbaijan 🇦🇿', flag: '🇦🇿', default: false, region: 'we' },
  { key: 'bh', label: 'Bahrain 🇧🇭', flag: '🇧🇭', default: false, region: 'we' },
  { key: 'be', label: 'Belgium 🇧🇪', flag: '🇧🇪', default: false, region: 'we' },
  { key: 'bg', label: 'Bulgaria 🇧🇬', flag: '🇧🇬', default: false, region: 'we' },
  { key: 'kh', label: 'Cambodia 🇰🇭', flag: '🇰🇭', default: false, region: 'ea' },
  { key: 'ca', label: 'Canada 🇨🇦', flag: '🇨🇦', default: false, region: 'eu' },
  { key: 'ic', label: 'Canary Islands 🇮🇨', flag: '🇮🇨', default: false, region: 'we' },
  { key: 'hr', label: 'Croatia 🇭🇷', flag: '🇭🇷', default: false, region: 'we' },
  { key: 'cy', label: 'Cyprus 🇨🇾', flag: '🇨🇾', default: false, region: 'we' },
  { key: 'cz', label: 'Czech 🇨🇿', flag: '🇨🇿', default: false, region: 'we' },
  { key: 'ge', label: 'Georgia 🇬🇪', flag: '🇬🇪', default: false, region: 'we' },
  { key: 'gr', label: 'Greece 🇬🇷', flag: '🇬🇷', default: false, region: 'we' },
  { key: 'fr', label: 'France 🇫🇷', flag: '🇫🇷', default: false, region: 'we' },
  { key: 'hk', label: 'Hong Kong 🇭🇰', flag: '🇭🇰', default: false, region: 'ea' },
  { key: 'id', label: 'Indonesia 🇮🇩', flag: '🇮🇩', default: false, region: 'ea' },
  { key: 'iq', label: 'Iraq 🇮🇶', flag: '🇮🇶', default: false, region: 'we' },
  { key: 'ie', label: 'Ireland 🇮🇪', flag: '🇮🇪', default: false, region: 'we' },
  { key: 'il', label: 'Israel 🇮🇱', flag: '🇮🇱', default: false, region: 'we' },
  { key: 'it', label: 'Italy 🇮🇹', flag: '🇮🇹', default: false, region: 'we' },
  { key: 'jo', label: 'Jordan 🇯🇴', flag: '🇯🇴', default: false, region: 'we' },
  { key: 'kz', label: 'Kazakhstan 🇰🇿', flag: '🇰🇿', default: false, region: 'ea' },
  { key: 'kw', label: 'Kuwait 🇰🇼', flag: '🇰🇼', default: false, region: 'we' },
  { key: 'ly', label: 'Libya 🇱🇾', flag: '🇱🇾', default: false, region: 'we' },
  { key: 'md', label: 'Moldova 🇲🇩', flag: '🇲🇩', default: false, region: 'we' },
  { key: 'me', label: 'Montenegro 🇲🇪', flag: '🇲🇪', default: false, region: 'we' },
  { key: 'ma', label: 'Morocco 🇲🇦', flag: '🇲🇦', default: false, region: 'we' },
  { key: 'mm', label: 'Myanmar 🇲🇲', flag: '🇲🇲', default: false, region: 'ea' },
  { key: 'my', label: 'Malaysia 🇲🇾', flag: '🇲🇾', default: false, region: 'ea' },
  { key: 'ph', label: 'Philippines 🇵🇭', flag: '🇵🇭', default: false, region: 'ea' },
  { key: 'pl', label: 'Poland 🇵🇱', flag: '🇵🇱', default: false, region: 'we' },
  { key: 'pt', label: 'Portugal 🇵🇹', flag: '🇵🇹', default: false, region: 'we' },
  { key: 'ro', label: 'Romania 🇷🇴', flag: '🇷🇴', default: false, region: 'we' },
  { key: 'sa', label: 'Saudi Arabia 🇸🇦', flag: '🇸🇦', default: false, region: 'we' },
  { key: 'rs', label: 'Serbia 🇷🇸', flag: '🇷🇸', default: false, region: 'we' },
  { key: 'sg', label: 'Singapore 🇸🇬', flag: '🇸🇬', default: false, region: 'ea' },
  { key: 'sk', label: 'Slovakia 🇸🇰', flag: '🇸🇰', default: false, region: 'we' },
  { key: 'si', label: 'Slovenia 🇸🇮', flag: '🇸🇮', default: false, region: 'we' },
  { key: 'za', label: 'South Africa 🇿🇦', flag: '🇿🇦', default: false, region: 'we' },
  { key: 'es', label: 'Spain 🇪🇸', flag: '🇪🇸', default: false, region: 'we' },
  { key: 'se', label: 'Sweden 🇸🇪', flag: '🇸🇪', default: false, region: 'we' },
  { key: 'ch', label: 'Switzerland 🇨🇭', flag: '🇨🇭', default: false, region: 'we' },
  { key: 'tn', label: 'Tunisia 🇹🇳', flag: '🇹🇳', default: false, region: 'we' },
  { key: 'tr', label: 'Turkey 🇹🇷', flag: '🇹🇷', default: false, region: 'we' },
  { key: 'ae', label: 'United Arab Emirates 🇦🇪', flag: '🇦🇪', default: false, region: 'we' },
  { key: 'uk', label: 'United Kingdom 🇬🇧', flag: '🇬🇧', default: false, region: 'we' },
  { key: 'us', label: 'United States 🇺🇸', flag: '🇺🇸', default: false, region: 'eu' },
  { key: 'vn', label: 'Vietnam 🇻🇳', flag: '🇻🇳', default: false, region: 'ea' },
]

export const AzureRegions = {
  we: 'Western Europe',
  ea: 'Eastern Asia',
  eu: 'United States',
  other: 'Other',
}

export default AzurePipelineMarkets
